import React from 'react';
import { Icons } from '../../../../assets';
import ContainerModal from '../container-modal';
import { ButtonCustom } from '../../../../components';

import * as s from './styled-modal-cancelar-edicao-contratante';

const ModalCancelarEdicao = ({ isOpen, closeModal, readOnlyClick }) => {
	
	return (
		<ContainerModal isOpen={isOpen} closeModal={closeModal}>
			<s.Content>
				<s.Imagem>
					<Icons.InfoTriangleIcon />
				</s.Imagem>
				<s.Title>CANCELAR EDIÇÃO DE CONTRATANTE</s.Title>
				<s.Subtitle>
					Tem certeza que deseja cancelar a edição deste contratante? <br />{' '}
					Todas as informações serão perdidas.
				</s.Subtitle>
				<s.ButtonGroup>
					<ButtonCustom width="15rem" textTransform="none" onClick={closeModal}>
						Não, quero manter
					</ButtonCustom>
					<ButtonCustom
						textTransform="none"
						outlined
						width="15rem"
						theme="alert-white"
						onClick={() => {
							readOnlyClick();
							closeModal();
						}}
						className="button-custom-cancelar"
					>
						Sim, quero cancelar
					</ButtonCustom>
				</s.ButtonGroup>
			</s.Content>
		</ContainerModal>
	);
};

export default ModalCancelarEdicao;
